export default function (state, data) {
    state.items = [];
    data.forEach(i => {
        state.items.push(i);
    })
}